// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__NcoIp","header":"MessagesList_header__77Dca","chat":"MessagesList_chat__3WbbC"};